module.exports = __webpack_public_path__ + "static/media/touch_icon_one.2f00550f.svg";